export default __webpack_public_path__ + "static/media/background-light.b1a1406a.webp";